import { Build, h, Host } from "@stencil/core";
export class Tab {
    constructor() {
        this.selected = false;
    }
    connectedCallback() {
        const parent = this.el.parentElement;
        if (parent.nodeName === 'UVEX-TABS' && parent.querySelector('.tabs-inner')) {
            parent.querySelector('.tabs-inner').append(this.el);
        }
        this.uvexTabAdded.emit();
    }
    disconnectedCallback() {
        if (Build.isBrowser) {
            document.dispatchEvent(new CustomEvent('uvexTabRemoved'));
        }
    }
    selectedChanged(selected) {
        if (selected) {
            this.uvexSelect.emit();
        }
    }
    onPropChanged() {
        this.uvexTabMutated.emit();
    }
    render() {
        const { btnId, selected } = this;
        return (h(Host, { key: '875a48fed92022f24dd21ad2cd83fd516c409270', "aria-labelledby": btnId, "aria-hidden": !selected ? 'true' : null, role: "tabpanel", class: {
                'tab-hidden': !selected
            } }, h("slot", { key: '31a03ecc1a98df4e3d77033d97c6ac6724b86f34' })));
    }
    static get is() { return "uvex-tab"; }
    static get properties() {
        return {
            "selected": {
                "type": "boolean",
                "attribute": "selected",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "false"
            },
            "btnId": {
                "type": "string",
                "attribute": "btn-id",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false
            },
            "label": {
                "type": "string",
                "attribute": "label",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": true
            }
        };
    }
    static get events() {
        return [{
                "method": "uvexSelect",
                "name": "uvexSelect",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "void",
                    "resolved": "void",
                    "references": {}
                }
            }, {
                "method": "uvexTabMutated",
                "name": "uvexTabMutated",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "void",
                    "resolved": "void",
                    "references": {}
                }
            }, {
                "method": "uvexTabAdded",
                "name": "uvexTabAdded",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "void",
                    "resolved": "void",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "selected",
                "methodName": "selectedChanged"
            }, {
                "propName": "label",
                "methodName": "onPropChanged"
            }];
    }
}
//# sourceMappingURL=tab.js.map
